import { createAction } from 'redux-actions';
import * as types from './actionTypes';

export const feedMappingsRequest = createAction(types.FEED_MAPPINGS_REQUEST);
export const feedMappingsSuccess = createAction(types.FEED_MAPPINGS_SUCCESS);
export const feedMappingsFailure = createAction(types.FEED_MAPPINGS_FAILURE);

export const feedMappingRequest = createAction(types.FEED_MAPPING_REQUEST);
export const feedMappingSuccess = createAction(types.FEED_MAPPING_SUCCESS);
export const feedMappingFailure = createAction(types.FEED_MAPPING_FAILURE);

export const createFeedMappingRequest = createAction(
  types.CREATE_FEED_MAPPING_REQUEST,
);
export const createFeedMappingSuccess = createAction(
  types.CREATE_FEED_MAPPING_SUCCESS,
);
export const createFeedMappingFailure = createAction(
  types.CREATE_FEED_MAPPING_FAILURE,
);

export const updateFeedMappingRequest = createAction(
  types.UPDATE_FEED_MAPPING_REQUEST,
);
export const updateFeedMappingSuccess = createAction(
  types.UPDATE_FEED_MAPPING_SUCCESS,
);
export const updateFeedMappingFailure = createAction(
  types.UPDATE_FEED_MAPPING_FAILURE,
);

export const deleteFeedMappingRequest = createAction(
  types.DELETE_FEED_MAPPING_REQUEST,
);
export const deleteFeedMappingSuccess = createAction(
  types.DELETE_FEED_MAPPING_SUCCESS,
);
export const deleteFeedMappingFailure = createAction(
  types.DELETE_FEED_MAPPING_FAILURE,
);

export const resetFeedMapping = createAction(types.RESET_FEED_MAPPING);

export default {
  resetFeedMapping,
  feedMappingsRequest,
  feedMappingsSuccess,
  feedMappingsFailure,
  feedMappingRequest,
  feedMappingSuccess,
  feedMappingFailure,
  createFeedMappingRequest,
  createFeedMappingSuccess,
  createFeedMappingFailure,
  updateFeedMappingRequest,
  updateFeedMappingSuccess,
  updateFeedMappingFailure,
  deleteFeedMappingRequest,
  deleteFeedMappingSuccess,
  deleteFeedMappingFailure,
};
